import { normalizeAppPath } from "../utils/normalizeAppPath";

export const APP_IDS = {
  LEADS: "leads",
  ACADEMICS: "academics",
  SCHEDULER: "scheduler",
  FINANCE: "finance",
  MARKETING: "marketing",
  PERFORMANCE: "performance",
  COMMUNICATION: "communication",
  ADMIN: "admin",
  REPORTS: "reports",
};

const {
  LEADS,
  ACADEMICS,
  SCHEDULER,
  FINANCE,
  MARKETING,
  PERFORMANCE,
  COMMUNICATION,
  ADMIN,
  REPORTS,
} = APP_IDS;

/** First matching rule wins (most specific prefixes first). */
const RULES = [
  { app: MARKETING, test: (p) => p.startsWith("/marketing-intelligence") || p.startsWith("/marketing/") },
  { app: ACADEMICS, test: (p) => p.startsWith("/universities") || p.startsWith("/programs") },
  { app: FINANCE, test: (p) => p === "/accounts-dashboard" || p.startsWith("/accounts/") || p.startsWith("/settings/finance") },
  { app: REPORTS, test: (p) => p === "/reports" || p.startsWith("/reports/") },
  {
    app: SCHEDULER,
    test: (p) =>
      p.startsWith("/schedule") ||
      p.startsWith("/register/") ||
      p.startsWith("/book/") ||
      p === "/event-access" ||
      p === "/event-scan",
  },
  {
    app: PERFORMANCE,
    test: (p) =>
      p.startsWith("/incentives") ||
      p.startsWith("/bonuses") ||
      p.startsWith("/bounties") ||
      p.startsWith("/targets") ||
      p.startsWith("/commissions") ||
      p === "/my-commissions" ||
      p === "/staff",
  },
  { app: COMMUNICATION, test: (p) => p === "/whatsapp-inbox" || p === "/unified-inbox" },
  {
    app: ADMIN,
    test: (p) =>
      p === "/users" ||
      p === "/userProfile" ||
      p === "/server-logs" ||
      p === "/ai-usage" ||
      p === "/notifications" ||
      p === "/ai-chat" ||
      p.startsWith("/admin/app-builder"),
  },
  {
    app: LEADS,
    test: (p) =>
      p.startsWith("/appointments") ||
      p === "/home" ||
      p === "/back-office-dashboard" ||
      p === "/counsellor-dashboard" ||
      p === "/all-enquiry" ||
      p === "/new-enquiry" ||
      p === "/create-enquiry" ||
      p === "/followups" ||
      p === "/exhibition-enquiries" ||
      p === "/assign-visa-counsellor" ||
      p === "/view-applications" ||
      p === "/counsellor-applications" ||
      p === "/enquiry_profile" ||
      p === "/edit_enquiry" ||
      p === "/tasks" ||
      p === "/approvals",
  },
  { app: LEADS, test: () => true },
];

export function getAppIdFromPath(pathname) {
  const p = normalizeAppPath(pathname);
  for (const { test, app } of RULES) {
    if (test(p)) return app;
  }
  return LEADS;
}

/** Migrate legacy stored module id. */
export function normalizeStoredAppId(id) {
  if (id === "crm") return APP_IDS.LEADS;
  return id;
}

/** Apps whose launcher + sidebar are only for the `admin` role (see `appMenus.jsx`). */
export const ADMIN_ONLY_APP_IDS = [APP_IDS.ADMIN, APP_IDS.COMMUNICATION];
